















import {
    PropType,
    computed,
    defineComponent,
} from '@vue/composition-api';
import { PeriodData } from '@models/user/Limit';

export default defineComponent({
    props: {
        limitPeriodData: {
            type: Object as PropType<PeriodData>,
            required: true,
        },
    },
    setup(props) {
        const amount = computed(() => props.limitPeriodData.previousAmount || props.limitPeriodData.amount);
        const spendAmount = computed(() => Number((amount.value - props.limitPeriodData.limitRemaining).toFixed(2)));
        const percentage = computed(() => Math.min(Math.max(Math.round(spendAmount.value / amount.value * 100), 0), 100));

        return {
            amount,
            spendAmount,
            percentage,
        };
    },
    components: {},
});
